<script>
  import { onDestroy, onMount } from "svelte";
  import { Label, Input, Collapse } from "sveltestrap";
  import { encodingMap } from "../../editor/component/mark.js";

  import ItemResponse from "./ItemResponse.svelte";
  export let status;
  export let legendCandidates;
  export let legend;
  export let inputFocusAction;
  export let inputBlurAction;
  export let updateLegend;
  export let afterDelete;

  let showLegendLabel;
  if (legend?.items !== undefined) {
    showLegendLabel =
      legend?.items?.map((_) => (legend.items.length == 1 ? true : false)) ||
      [];
  }

  let newCustomValue, newCustomText;
  onMount(() => {
    if (showLegendLabel === undefined) {
      if (legend?.items !== undefined)
        showLegendLabel = legend.items.map((_) =>
          legend.items.length == 1 ? true : false
        );
    }
    newCustomValue = undefined;
    newCustomText = undefined;
  });
  onDestroy(() => {
    newCustomValue = undefined;
    newCustomText = undefined;
  });
</script>

{#if status === "new"}
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <p class="text-sm">Pick a channel to add a legend.</p>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">
        <i class="bi bi-flower3 me-1" /> Mark property channels
      </h3>
    </div>
    {#each legendCandidates as cand}
      <div class="dupo-menu-pane-form-row">
        <button
          type="button"
          class="menu-second-level"
          on:click={(event) => {
            updateLegend("new", "legend", cand);
            status = "edit";
            legend = { type: "legend", channel: cand.channel };
            if (cand.field) legend.field = cand.field;
            if (cand.aggregate) legend.aggregate = cand.aggregate;
          }}
        >
          <img
            src={`../image/encoding/${encodingMap[cand.channel].icon}`}
            class="enc-icon"
            alt={encodingMap[cand.channel].name + " icon"}
          />{cand.layerName} / {cand.channel}
          <i class="bi bi-caret-right-fill my-1">
            {cand.field || cand.aggregate}
          </i></button
        >
      </div>
    {/each}
  </div>
{:else if status === "edit"}
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <div class="menu-second-level">
        <img
          src={`../image/encoding/${encodingMap[legend.channel].icon}`}
          class="enc-icon"
          alt={encodingMap[legend.channel].name + " icon"}
        />{legend.layerName} / {legend.channel}
      </div>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Data link</h3>
    </div>
  </div>
  <!-- field -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="text"
      token="field"
      title="Field"
      {inputFocusAction}
      {inputBlurAction}
      value={legend.field || legend.aggregate}
      readonly={true}
    />
  </div>
  <!-- values -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="text"
      token="values"
      title="Values"
      {inputFocusAction}
      {inputBlurAction}
      value={legend.values?.join(",") || ""}
      changeAction={(event) => {
        updateLegend(event, "legend.values", legend);
      }}
    />
  </div>
  <!-- global -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Positioning</h3>
    </div>
  </div>
  <!-- orient -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="orient"
      token="orient"
      title="Orient"
      topBottom={true}
      leftRight={true}
      tblr6pos={false}
      tblr4pos={true}
      none={true}
      {inputFocusAction}
      {inputBlurAction}
      value={legend.orient}
      changeAction={(event) => {
        updateLegend(event, "legend.orient", legend);
      }}
    />
  </div>
  <!-- direction -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <Label for="direction">Direction</Label>
    </div>
    <div class="dupo-menu-pane-form-row">
      <Input
        name="direction"
        id="direction"
        type="select"
        class="custom-form-select"
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        value={legend.direction}
        on:change={(event) => {
          updateLegend(event, "legend.direction", legend);
        }}
      >
        <option value={undefined} />
        <option value="none">Auto</option>
        <option value="horizontal">Horizontal</option>
        <option value="vertical">Vertical</option>
      </Input>
    </div>
  </div>
  <!-- offset & position-->
  {#if legend.orient !== "none"}
    <!-- offset: if not manual -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="size"
        token="offset"
        title="Offset (from the chart)"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.offset}
        changeAction={(event) => {
          updateLegend(event, `legend.offset`, legend);
        }}
      />
    </div>
  {:else}
    <!-- position if manual -->
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <Label>Position</Label>
      </div>
      <div class="dupo-menu-pane-form-row">
        <div class="form-wrap">
          <Label for="position-x" style="width: 55%;">X</Label>
          <Label for="position-y" style="width: 45%;">Y</Label>
        </div>
      </div>
      <div class="dupo-menu-pane-form-row">
        <div class="form-wrap">
          <Input
            name="position-x"
            id="position-x"
            type="number"
            class="custom-form-select"
            min="0"
            autocomplete="off"
            style="width: 50%;"
            on:focus={inputFocusAction}
            on:blur={inputBlurAction}
            value={legend.x}
            on:change={(event) => {
              updateLegend(event, "legend.x", legend);
            }}
          />
          <Input
            name="position-y"
            id="position-y"
            type="number"
            class="custom-form-select"
            min="0"
            autocomplete="off"
            style="width: 50%;"
            on:focus={inputFocusAction}
            on:blur={inputBlurAction}
            value={legend.y}
            on:change={(event) => {
              updateLegend(event, "legend.y", legend);
            }}
          />
        </div>
      </div>
    </div>
  {/if}
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="size"
      token="gap"
      title="Gap (between elements)"
      {inputFocusAction}
      {inputBlurAction}
      value={legend.gap}
      changeAction={(event) => {
        updateLegend(event, `legend.gap`, legend);
      }}
    />
  </div>

  <!-- interactive -->
  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Interactive</h3>
    </div>
  </div>

  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="select"
      token="interactive-highlight"
      title="Interactive highlight"
      {inputFocusAction}
      {inputBlurAction}
      options={[null, "mouseover", "click"]}
      optionNames={["No", "Hover", "Click"]}
      value={legend.interactiveHighlight !== undefined}
      changeAction={(event) => {
        updateLegend(event, "legend.interactiveHighlight", legend);
      }}
    />
  </div>

  <!-- per item -->
  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Legend labels</h3>
    </div>
  </div>
  {#if legend.items !== undefined && legend.items.length > 0}
    {#each legend.items as textItem, ti}
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-form-row">
          <button
            type="button"
            class="menu-second-level"
            on:click={() => {
              showLegendLabel[ti] = !showLegendLabel[ti];
            }}
            ><i
              class={`bi bi-caret-${
                showLegendLabel[ti] ? "down-fill" : "right"
              }`}
            />Legend label {ti + 1}</button
          >
        </div>
      </div>
      <Collapse isOpen={showLegendLabel[ti]}>
        <div class="dupo-menu-pane">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Layout</h3>
          </div>
        </div>

        <!-- width -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="width"
            token={"width-" + ti}
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.fontWeight}
            changeAction={(event) => {
              updateLegend(event, `legend.items.${ti}.width`, legend);
            }}
          />
        </div>

        <div class="dupo-menu-pane mt-3">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Font style</h3>
          </div>
        </div>

        <!-- font size -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="fontSize"
            token={"fontSize-" + ti}
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.fontSize || 12}
            changeAction={(event) => {
              updateLegend(event, `legend.items.${ti}.fontSize`, legend);
            }}
          />
        </div>

        <!-- font color -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="color"
            token={"color-" + ti}
            title="Font color"
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.color}
            changeAction={(event) => {
              updateLegend(event, `legend.items.${ti}.color`, legend);
            }}
          />
        </div>

        <!-- font weight -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="fontWeight"
            token={"fontWeight-" + ti}
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.fontWeight}
            changeAction={(event) => {
              updateLegend(event, `legend.items.${ti}.fontWeight`, legend);
            }}
          />
        </div>

        <!-- opacity -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="opacity"
            token={"opacity-" + ti}
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.opacity || 1}
            changeAction={(event) => {
              updateLegend(event, `legend.items.${ti}.opacity`, legend);
            }}
          />
        </div>

        <div class="dupo-menu-pane mt-3">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Text formatting</h3>
          </div>
        </div>

        <!-- format -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="text"
            token={"format-" + ti}
            title="Format string"
            {inputFocusAction}
            {inputBlurAction}
            value={textItem.format}
            changeAction={(event) => {
              updateLegend(event, `legend.items.${ti}.format`, legend);
            }}
          />
        </div>

        <!-- expression -->
        {#if legend.field}
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="data-expression"
              token={"expression-" + ti}
              title="Expression"
              {inputFocusAction}
              {inputBlurAction}
              value={textItem.expression}
              field={legend.field}
              values={textItem.values || legend.values || []}
              changeAction={(event) => {
                updateLegend(event, `legend.items.${ti}.expression`, legend);
              }}
            />
          </div>
        {/if}

        <!-- custom -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-row">
            <Label for={"custom-" + ti}>Custom per value</Label>
          </div>

          {#if textItem.customList !== undefined}
            {#each textItem.customList as custom, ci}
              <div class="dupo-menu-pane-form-row d-flex">
                <Label
                  for={"custom-" + ti + "-value-" + ci}
                  style="width: 43%;"
                  class="text-sm mb-0">Value {ci + 1}</Label
                >
                <Label
                  for={"custom-" + ti + "-text-" + ci}
                  style="width: 53%;"
                  class="text-sm mb-0">Text {ci + 1}</Label
                >
                <Label style="width: 4%;" class="text-sm mb-0">-</Label>
              </div>
              <div class="dupo-menu-pane-form-row mb-1 d-flex">
                <div class="form-wrap">
                  <Input
                    id={"custom-" + ti + "-value-" + ci}
                    name={"custom-" + ti + "-value-" + ci}
                    type="text"
                    autocomplete="off"
                    class="custom-form-select"
                    style="width: 40%;"
                    on:focus={inputFocusAction}
                    on:blur={inputBlurAction}
                    bind:value={custom.value}
                    on:change={(event) => {
                      updateLegend(
                        textItem.customList,
                        `legend.items.${ti}.custom`,
                        legend
                      );
                    }}
                  />
                  <Input
                    id={"custom-" + ti + "-text-" + ci}
                    name={"custom-" + ti + "-text-" + ci}
                    type="text"
                    autocomplete="off"
                    class="custom-form-select"
                    style="width: 50%;"
                    on:focus={inputFocusAction}
                    on:blur={inputBlurAction}
                    bind:value={custom.text}
                    on:change={(event) => {
                      updateLegend(
                        textItem.customList,
                        `legend.items.${ti}.custom`,
                        legend
                      );
                    }}
                  />
                  <button
                    type="button"
                    class="custom-form-select"
                    style="width: 10%; padding-left: 0; padding-right: 0;"
                    on:click={(event) => {
                      textItem.customList.splice(ci, 1);
                      updateLegend(
                        textItem.customList,
                        `legend.items.${ti}.custom`,
                        legend
                      );
                    }}
                    ><i
                      class="bi bi-trash-fill"
                      alt="delete this custom item"
                    /></button
                  >
                </div>
              </div>
            {/each}
          {/if}
          <div class="dupo-menu-pane-form-row d-flex">
            <Label
              for={"custom-" + ti + "-value-new"}
              style="width: 43%;"
              class="text-sm mb-0">New value</Label
            >
            <Label
              for={"custom-" + ti + "-text-new"}
              style="width: 53%;"
              class="text-sm mb-0">New text</Label
            >
            <Label style="width: 4%;" class="text-sm mb-0">+</Label>
          </div>
          <div class="dupo-menu-pane-form-row mb-1 d-flex">
            <div class="form-wrap">
              <Input
                id={"custom-" + ti + "-value-new"}
                name={"custom-" + ti + "-value-new"}
                type="text"
                autocomplete="off"
                class="custom-form-select"
                style="width: 40%;"
                on:focus={inputFocusAction}
                on:blur={inputBlurAction}
                bind:value={newCustomValue}
              />
              <Input
                id={"custom-" + ti + "-text-new"}
                name={"custom-" + ti + "-text-new"}
                type="text"
                autocomplete="off"
                class="custom-form-select"
                style="width: 50%;"
                on:focus={inputFocusAction}
                on:blur={inputBlurAction}
                bind:value={newCustomText}
              />
              <button
                type="button"
                class="custom-form-select"
                style="width: 10%; padding-left: 0; padding-right: 0;"
                on:click={(event) => {
                  updateLegend(
                    { newCustomValue, newCustomText },
                    `legend.items.${ti}.custom`,
                    legend
                  );
                  newCustomValue = undefined;
                  newCustomText = undefined;
                }}
                ><i
                  class="bi bi-plus-circle"
                  alt="add this custom item"
                /></button
              >
            </div>
          </div>
        </div>
        <!-- delete buttion (if more than 1) -->
        {#if legend.items.length > 1}
          <div class="pane-divider" />
          <div class="dupo-menu-pane">
            <div class="dupo-menu-pane-button-row">
              <button
                type="button"
                on:click={(event) => {
                  updateLegend("delete", `legend.items.${ti}`, legend);
                }}
              >
                <i class="bi bi-eraser me-1" /> Delete this line
              </button>
            </div>
          </div>
        {/if}
      </Collapse>
    {/each}
  {/if}

  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-button-row">
      <button
        type="button"
        on:click={(event) => {
          updateLegend("add", `legend.items`, legend);
        }}
      >
        <i class="bi bi-plus-circle me-1" /> Add a new text line
      </button>
    </div>
  </div>

  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Legend title</h3>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      token="use-title"
      title="Use title"
      {inputFocusAction}
      {inputBlurAction}
      value={legend.title !== undefined}
      changeAction={(event) => {
        updateLegend(event, "legend.title", legend);
      }}
    />
  </div>
  {#if legend.title !== undefined}
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="text"
        token="title-text"
        title="Title text"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.value}
        changeAction={(event) => {
          updateLegend(event, "legend.title.text", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="textAlign"
        token="title-align"
        title="Title align"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.align}
        changeAction={(event) => {
          updateLegend(event, "legend.title.textAlign", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="color"
        token="title-color"
        title="Title font color"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.color || "rgba(0,0,0,1)"}
        changeAction={(event) => {
          updateLegend(event, "legend.title.color", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="size"
        token="title-fontSize"
        title="Title font size"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.fontSize || 12}
        changeAction={(event) => {
          updateLegend(event, "legend.title.fontSize", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="fontWeight"
        token="title-fontWeight"
        title="Title font weight"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.fontWeight}
        changeAction={(event) => {
          updateLegend(event, "legend.title.fontWeight", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="opacity"
        token="title-opacity"
        title="Title opacity"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.opacity || 1}
        changeAction={(event) => {
          updateLegend(event, "legend.title.opacity", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="size"
        token="title-marginTop"
        title="Title margin top"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.marginTop}
        changeAction={(event) => {
          updateLegend(event, "legend.title.marginTop", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="size"
        token="title-marginBottom"
        title="Title margin bottom"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.marginBottom}
        changeAction={(event) => {
          updateLegend(event, "legend.title.marginBottom", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="size"
        token="title-marginLeft"
        title="Title margin left"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.marginLeft}
        changeAction={(event) => {
          updateLegend(event, "legend.title.marginLeft", legend);
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="size"
        token="title-marginRight"
        title="Title margin right"
        {inputFocusAction}
        {inputBlurAction}
        value={legend.title?.marginRight}
        changeAction={(event) => {
          updateLegend(event, "legend.title.marginRight", legend);
        }}
      />
    </div>
  {/if}

  <!-- lock -->
  <div class="pane-divider" />
  <div class="dupo-menu-pane pt-2 mb-2">
    <ItemResponse
      type="lock"
      tooltipMessage="Prevent suggesting responsive alternatives that make changes to this legend (not position). Element-Lock applies to its source or target design(s)."
      title="Lock this legend"
      token={"legend-lock"}
      value={legend?.lock}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateLegend(event, "legend.lock", legend);
      }}
    />
    <div class="dupo-menu-pane-row">
      <p class="text-sm">Does not apply to the position of this legend.</p>
    </div>
  </div>
  <div class="dupo-menu-pane">
    <ItemResponse
      type="lock"
      tooltipMessage="Prevent suggesting responsive alternatives that reposition this legend. Element-Lock applies to its source or target design(s)."
      title="Don't reposition"
      token={"position-lock"}
      value={legend?.positionLock}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateLegend(event, "position.lock", legend);
      }}
    />
  </div>

  <!-- Remove this legend -->
  <div class="pane-divider" />
  <div class="dupo-menu-pane mt-5">
    <div class="dupo-menu-pane-button-row">
      <button
        type="button"
        on:click={(event) => {
          updateLegend("delete", "legend", legend);
          if (afterDelete) afterDelete();
        }}
      >
        <i class="bi bi-trash-fill me-1" /> Delete this legend
      </button>
    </div>
  </div>
{/if}

<style>
  .color-name {
    max-width: 150px;
    overflow: hidden;
    vertical-align: middle;
    text-overflow: ellipsis;
  }
</style>
